import { useEffect, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import PageHeader from '../components/PageHeader';
import Section from '../components/Section';
import { updatePageMeta } from '../lib/seo';

// Import new lab images from new-gallary folder
import lab1 from "../assets/new-gallary/lab-1.jpeg";
import lab2 from "../assets/new-gallary/lab-2.jpeg";
import lab3 from "../assets/new-gallary/lab-3.jpeg";
import lab4 from "../assets/new-gallary/lab-4.jpeg";
import lab5 from "../assets/new-gallary/lab-5.jpeg";
import lab6 from "../assets/new-gallary/lab-6.jpeg";
import lab7 from "../assets/new-gallary/lab-7.jpeg";
import lab8 from "../assets/new-gallary/lab-8.jpeg";
import lab9 from "../assets/new-gallary/lab-9.jpeg";
import lab10 from "../assets/new-gallary/lab-10.jpeg";
import lab11 from "../assets/new-gallary/lab-11.jpeg";
import lab12 from "../assets/new-gallary/lab-12.jpeg";
import lab14 from "../assets/new-gallary/lab-14.jpeg";
import lab15 from "../assets/new-gallary/lab-15.jpeg";
import lab16 from "../assets/new-gallary/lab-16.jpeg";
import lab17 from "../assets/new-gallary/lab-17.jpeg";

// Import new team images from new-gallary folder
import team1 from "../assets/new-gallary/team-1.jpeg";
import team2 from "../assets/new-gallary/team-2.jpeg";
import team3 from "../assets/new-gallary/team-3.jpeg";
import team4 from "../assets/new-gallary/team-4.jpeg";
import team5 from "../assets/new-gallary/team-5.jpeg";
import team6 from "../assets/new-gallary/team-6.jpeg";
import team7 from "../assets/new-gallary/team-7.jpeg";
import team8 from "../assets/new-gallary/team-8.jpeg";
import team9 from "../assets/new-gallary/team-9.jpeg";
import team10 from "../assets/new-gallary/team-10.jpeg";
import team11 from "../assets/new-gallary/team-11.jpeg";
import team12 from "../assets/new-gallary/team-12.jpeg";
import team13 from "../assets/new-gallary/team-13.jpeg";

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [galleryItems, setGalleryItems] = useState([]);

  useEffect(() => {
    updatePageMeta({
      title: 'Gallery - EnviroTech Solutions',
      description: 'View our laboratory facilities, field operations, treatment plants, and project implementations.',
    });
  }, []);

  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Gallery' },
  ];

  // Lab images data
  const labImages = [
    { original: lab1, thumbnail: lab1, description: 'Laboratory facility view 1' },
    { original: lab2, thumbnail: lab2, description: 'Laboratory facility view 2' },
    { original: lab3, thumbnail: lab3, description: 'Laboratory facility view 3' },
    { original: lab4, thumbnail: lab4, description: 'Laboratory facility view 4' },
    { original: lab5, thumbnail: lab5, description: 'Laboratory facility view 5' },
    { original: lab6, thumbnail: lab6, description: 'Laboratory facility view 6' },
    { original: lab7, thumbnail: lab7, description: 'Laboratory facility view 7' },
    { original: lab8, thumbnail: lab8, description: 'Laboratory facility view 8' },
    { original: lab9, thumbnail: lab9, description: 'Laboratory facility view 9' },
    { original: lab10, thumbnail: lab10, description: 'Laboratory facility view 10' },
    { original: lab11, thumbnail: lab11, description: 'Laboratory facility view 11' },
    { original: lab12, thumbnail: lab12, description: 'Laboratory facility view 12' },
    { original: lab14, thumbnail: lab14, description: 'Laboratory facility view 14' },
    { original: lab15, thumbnail: lab15, description: 'Laboratory facility view 15' },
    { original: lab16, thumbnail: lab16, description: 'Laboratory facility view 16' },
    { original: lab17, thumbnail: lab17, description: 'Laboratory facility view 17' },
  ];

  // Team images data
  const teamImages = [
    { original: team1, thumbnail: team1, description: 'Team and training session 1' },
    { original: team2, thumbnail: team2, description: 'Team and training session 2' },
    { original: team3, thumbnail: team3, description: 'Team and training session 3' },
    { original: team4, thumbnail: team4, description: 'Team and training session 4' },
    { original: team5, thumbnail: team5, description: 'Team and training session 5' },
    { original: team6, thumbnail: team6, description: 'Team and training session 6' },
    { original: team7, thumbnail: team7, description: 'Team and training session 7' },
    { original: team8, thumbnail: team8, description: 'Team and training session 8' },
    { original: team9, thumbnail: team9, description: 'Team and training session 9' },
    { original: team10, thumbnail: team10, description: 'Team and training session 10' },
    { original: team11, thumbnail: team11, description: 'Team and training session 11' },
    { original: team12, thumbnail: team12, description: 'Team and training session 12' },
    { original: team13, thumbnail: team13, description: 'Team and training session 13' },
  ];

  const galleries = [
    {
      title: 'Team & Training',
      description: 'Our experts at work and conducting training programs',
      images: teamImages,
    },
    {
      title: 'Laboratory Facilities',
      description: 'State-of-the-art analytical instruments and testing facilities',
      images: labImages,
    },
   
  ];

  const handleImageClick = (galleryIndex, imageIndex) => {
    const selectedGallery = galleries[galleryIndex];
    setGalleryItems(selectedGallery.images);
    setCurrentIndex(imageIndex);
    setIsOpen(true);
    // Prevent body scroll when lightbox is open
    document.body.style.overflow = 'hidden';
  };

  const handleCloseLightbox = () => {
    setIsOpen(false);
    document.body.style.overflow = 'unset';
  };

  // Close lightbox on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        handleCloseLightbox();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen]);

  return (
    <>
      {/* Page Header */}
      <PageHeader
        title="Gallery"
        description="A visual journey through our facilities, operations, and project implementations"
        breadcrumbs={breadcrumbs}
      />

      {/* Image Sections */}
      {galleries.map((gallery, galleryIndex) => (
        <Section
          key={galleryIndex}
          title={gallery.title}
          subtitle={gallery.description}
          background={galleryIndex % 2 === 0 ? 'white' : 'gray'}
        >
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
            {gallery.images.map((image, imageIndex) => (
              <div
                key={imageIndex}
                className="w-full aspect-square rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.02] cursor-pointer group relative"
                onClick={() => handleImageClick(galleryIndex, imageIndex)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleImageClick(galleryIndex, imageIndex);
                  }
                }}
                aria-label={`View ${image.description || `image ${imageIndex + 1}`} in lightbox`}
              >
                <img
                  src={image.thumbnail}
                  alt={image.description || `Gallery image ${imageIndex + 1}`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity duration-300" />
              </div>
            ))}
          </div>
        </Section>
      ))}

      {/* Lightbox Modal */}
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-95 flex items-center justify-center p-4 animate-fade-in"
          onClick={handleCloseLightbox}
          role="dialog"
          aria-modal="true"
          aria-label="Image gallery lightbox"
        >
          <div
            className="relative w-full max-w-6xl max-h-[90vh] gallery-lightbox-container"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseLightbox}
              className="absolute top-4 right-4 z-10 text-white hover:text-gray-300 transition-colors bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-70 focus:outline-none focus:ring-2 focus:ring-white"
              aria-label="Close lightbox"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <ImageGallery
              items={galleryItems}
              startIndex={currentIndex}
              showThumbnails={true}
              showFullscreenButton={true}
              showPlayButton={false}
              showBullets={false}
              autoPlay={false}
              slideDuration={450}
              slideInterval={3000}
              thumbnailPosition="bottom"
              useBrowserFullscreen={true}
              lazyLoad={true}
              onSlide={(index) => setCurrentIndex(index)}
            />
          </div>
        </div>
      )}

      {/* Video Section */}
      <Section
        title="Virtual Tour"
        subtitle="Take a virtual tour of our facilities"
        background="pattern"
      >
        <div className="max-w-4xl mx-auto">
          <a
            href="https://www.youtube.com/@terraenvironlabs"
            target="_blank"
            rel="noopener noreferrer"
            className="block aspect-video bg-gradient-to-br from-accent-800 to-accent-900 rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] group cursor-pointer"
            aria-label="Visit our YouTube channel - Terra Environ Labs"
          >
            <div className="flex items-center justify-center h-full">
              <div className="text-center text-white p-8">
                <div className="text-7xl mb-4 group-hover:scale-110 transition-transform duration-300">🎥</div>
                <h3 className="text-2xl font-bold mb-2">Watch Our Virtual Tours</h3>
                <p className="text-accent-300 mb-4">
                  Experience our laboratory facilities and treatment plants through our YouTube channel.
                </p>
                <div className="inline-flex items-center gap-2 bg-white bg-opacity-20 hover:bg-opacity-30 px-6 py-3 rounded-lg transition-all duration-300 group-hover:bg-opacity-30">
                  <span className="font-medium">Visit YouTube Channel</span>
                  <svg
                    className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </div>
              </div>
            </div>
          </a>
        </div>
      </Section>
    </>
  );
}

export default Gallery;
